"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EASYEDA_PCB_LAYER_MAP = exports.EasyEdaPadShape = exports.EasyEdaPinType = exports.EasyEdaLineStyle = exports.EasyEdaPowerFlagStyle = exports.EasyEdaDocType = void 0;
var EasyEdaDocType;
(function (EasyEdaDocType) {
    EasyEdaDocType[EasyEdaDocType["UNKNOWN"] = 0] = "UNKNOWN";
    EasyEdaDocType[EasyEdaDocType["SCHEMATIC_SHEET"] = 1] = "SCHEMATIC_SHEET";
    EasyEdaDocType[EasyEdaDocType["SYMBOL"] = 2] = "SYMBOL";
    EasyEdaDocType[EasyEdaDocType["PCB"] = 3] = "PCB";
    EasyEdaDocType[EasyEdaDocType["PCB_COMPONENT"] = 4] = "PCB_COMPONENT";
    EasyEdaDocType[EasyEdaDocType["SCHEMATIC_LIST"] = 5] = "SCHEMATIC_LIST";
    EasyEdaDocType[EasyEdaDocType["PCB_MODULE"] = 14] = "PCB_MODULE";
})(EasyEdaDocType || (exports.EasyEdaDocType = EasyEdaDocType = {}));
var EasyEdaPowerFlagStyle;
(function (EasyEdaPowerFlagStyle) {
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["UNKNOWN"] = -1] = "UNKNOWN";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["CIRCLE"] = 0] = "CIRCLE";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["ARROW"] = 1] = "ARROW";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["BAR"] = 2] = "BAR";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["WAVE"] = 3] = "WAVE";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["POWER_GROUND"] = 4] = "POWER_GROUND";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["SIGNAL_GROUND"] = 5] = "SIGNAL_GROUND";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["EARTH"] = 6] = "EARTH";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["GOST_ARROW"] = 7] = "GOST_ARROW";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["GOST_POWER_GROUND"] = 8] = "GOST_POWER_GROUND";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["GOST_EARTH"] = 9] = "GOST_EARTH";
    EasyEdaPowerFlagStyle[EasyEdaPowerFlagStyle["GOST_BAR"] = 10] = "GOST_BAR";
})(EasyEdaPowerFlagStyle || (exports.EasyEdaPowerFlagStyle = EasyEdaPowerFlagStyle = {}));
var EasyEdaLineStyle;
(function (EasyEdaLineStyle) {
    EasyEdaLineStyle[EasyEdaLineStyle["SOLID"] = 0] = "SOLID";
    EasyEdaLineStyle[EasyEdaLineStyle["DASH"] = 1] = "DASH";
    EasyEdaLineStyle[EasyEdaLineStyle["DOT"] = 2] = "DOT";
})(EasyEdaLineStyle || (exports.EasyEdaLineStyle = EasyEdaLineStyle = {}));
var EasyEdaPinType;
(function (EasyEdaPinType) {
    EasyEdaPinType[EasyEdaPinType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    EasyEdaPinType[EasyEdaPinType["INPUT"] = 1] = "INPUT";
    EasyEdaPinType[EasyEdaPinType["OUTPUT"] = 2] = "OUTPUT";
    EasyEdaPinType[EasyEdaPinType["BIDIRECTIONAL"] = 3] = "BIDIRECTIONAL";
    EasyEdaPinType[EasyEdaPinType["PASSIVE"] = 4] = "PASSIVE";
})(EasyEdaPinType || (exports.EasyEdaPinType = EasyEdaPinType = {}));
var EasyEdaPadShape;
(function (EasyEdaPadShape) {
    EasyEdaPadShape["ELLIPSE"] = "ELLIPSE";
    EasyEdaPadShape["RECT"] = "RECT";
    EasyEdaPadShape["OVAL"] = "OVAL";
    EasyEdaPadShape["POLYGON"] = "POLYGON";
})(EasyEdaPadShape || (exports.EasyEdaPadShape = EasyEdaPadShape = {}));
exports.EASYEDA_PCB_LAYER_MAP = {
    1: "F.Cu",
    2: "B.Cu",
    3: "F.SilkS",
    4: "B.SilkS",
    5: "F.Paste",
    6: "B.Paste",
    7: "F.Mask",
    8: "B.Mask",
    10: "Edge.Cuts",
    11: "Eco1.User",
    12: "Dwgs.User",
    13: "F.Fab",
    14: "B.Fab",
    15: "Eco2.User",
    19: "F.Fab",
    21: "In1.Cu",
    22: "In2.Cu",
    23: "In3.Cu",
    24: "In4.Cu",
    25: "In5.Cu",
    26: "In6.Cu",
    27: "In7.Cu",
    28: "In8.Cu",
    29: "In9.Cu",
    30: "In10.Cu",
    31: "In11.Cu",
    32: "In12.Cu",
    33: "In13.Cu",
    34: "In14.Cu",
    35: "In15.Cu",
    36: "In16.Cu",
    37: "In17.Cu",
    38: "In18.Cu",
    39: "In19.Cu",
    40: "In20.Cu",
    41: "In21.Cu",
    42: "In22.Cu",
    43: "In23.Cu",
    44: "In24.Cu",
    45: "In25.Cu",
    46: "In26.Cu",
    47: "In27.Cu",
    48: "In28.Cu",
    49: "In29.Cu",
    50: "In30.Cu",
    99: "User.3",
    100: "User.4",
    101: "User.5",
};
//# sourceMappingURL=types.js.map